import { render, staticRenderFns } from "./Calls.vue?vue&type=template&id=955405fc&scoped=true"
import script from "./Calls.vue?vue&type=script&lang=js"
export * from "./Calls.vue?vue&type=script&lang=js"
import style0 from "./Calls.vue?vue&type=style&index=0&id=955405fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955405fc",
  null
  
)

export default component.exports